const roleLabels = { admin: "Gruppe 1 (Administrator)", editor: "Gruppe 2 (Redaktør)", member: "Gruppe 3 (Medlem)" };
const roleColors = { admin: "bg-purple-600/20 text-purple-400", editor: "bg-blue-600/20 text-blue-400", member: "bg-green-600/20 text-green-400" };

const ActivityTab = ({ history, loading, isAdmin }) => {
  return (
    <div>
      <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4">AKTIVITET & STATISTIK</h2>
      {loading ? (
        <div className="text-center py-12"><div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto" /></div>
      ) : (
        <div className="space-y-4">
          {history.map((m) => {
            const initials = (m.member_name || "?").split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
            const roleColor = { admin: "from-purple-600 to-purple-800", editor: "from-blue-600 to-blue-800", member: "from-green-600 to-green-800" };
            return (
              <div key={m.member_name} className="mc-card p-0 overflow-hidden" data-testid={`history-${m.member_name}`}>
                <div className="flex flex-col sm:flex-row">
                  <div className="flex items-center gap-4 p-5 sm:min-w-[300px]">
                    {m.profile_image ? (
                      <img src={m.profile_image} alt={m.member_name} className="w-16 h-16 rounded-xl object-cover flex-shrink-0 border-2 border-white/10" />
                    ) : (
                      <div className={`w-16 h-16 rounded-xl flex-shrink-0 flex items-center justify-center bg-gradient-to-br ${roleColor[m.role] || roleColor.member}`}>
                        <span className="text-white font-['Oswald'] font-bold text-xl">{initials}</span>
                      </div>
                    )}
                    <div className="min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-lg font-bold text-white">{m.nickname || m.member_name}</h3>
                        {m.is_active === false && <span className="px-2 py-0.5 rounded text-[10px] bg-red-600/20 text-red-400">Inaktiv</span>}
                      </div>
                      {m.nickname && <p className="text-gray-400 text-sm italic">Civilt kendt som: {m.member_name}</p>}
                      {m.email && <p className="text-gray-500 text-sm truncate">{m.email}</p>}
                      {isAdmin && <span className={`inline-block mt-1 px-2 py-0.5 rounded text-[10px] ${roleColors[m.role] || roleColors.member}`}>
                        {roleLabels[m.role] || "Gruppe 3"}
                      </span>}
                    </div>
                  </div>

                  <div className="flex-1 flex flex-col sm:flex-row items-start sm:items-center gap-4 p-5 pt-0 sm:pt-5 sm:border-l border-white/5">
                    <div className="flex gap-6 flex-wrap">
                      <div className="text-center">
                        <p className="text-2xl font-bold text-[#00d4ff]">{m.login_count || 0}</p>
                        <p className="text-gray-500 text-xs">Logins</p>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-white">{m.last_login ? new Date(m.last_login).toLocaleDateString("da-DK") : "\u2014"}</p>
                        <p className="text-gray-500 text-xs">Sidst set</p>
                      </div>
                      {m.created_at && (
                        <div className="text-center">
                          <p className="text-sm font-medium text-white">{new Date(m.created_at).toLocaleDateString("da-DK")}</p>
                          <p className="text-gray-500 text-xs">Oprettet</p>
                        </div>
                      )}
                    </div>

                    {m.devices && m.devices.length > 0 && (
                      <div className="ml-auto text-xs space-y-1">
                        {m.devices.slice(-3).reverse().map((d, i) => (
                          <div key={i} className="flex items-center gap-2 text-gray-400">
                            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${d.device === "Mobil" ? "bg-green-400" : "bg-blue-400"}`} />
                            <span>{d.device}</span>
                            <span className="text-gray-600">{new Date(d.timestamp).toLocaleDateString("da-DK")}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActivityTab;
